import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(31, 73, 125)',
      // main: '#000000',
    },
    secondary: {
      // main: '#000000',
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
